import { render } from "./qna.vue?vue&type=template&id=630726de"
import script from "./qna.vue?vue&type=script&lang=js"
export * from "./qna.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__